import XYZ from 'ol/source/XYZ';
import { createInstanceFactory } from '@tmapy/utils';
export const xyzSourceFactory = createInstanceFactory((options) => {
    return new XYZ({
        ...options,
        crossOrigin: options.crossOrigin ?? 'Anonymous',
    });
});
//# sourceMappingURL=xyzSourceFactory.js.map